import Util from "../common/util.js";
//var $ = require("zepto");
var $ = require("jquery");
var Cookies = require("js-cookie");

var Order = {
    //过滤覆盖原有元素
    fillOption: function (part, all) {
        $.each(part, function (k, v) {
            if (all[k]) part[k] = all[k];
            delete all[k];
        });
        return part;
    },
    //基本参数，不同的插件id不通的参数
    _option: {
        //下面是默认7000官网推荐的参数
        biz: "",
        _v: "", //v3会调用i_buy.cgi
        plug_id: 7000,
        appid: 1003, //1003默认pc
        channel: 90001, //子渠道
        _from: "h5", //来源
        tradeType: 2, //1表示赠送，2表示iActionid=2
        needVip: 0,
        jifen_dikou: 0, //本次购买是否积分抵扣
        iGameType: "", //游戏类型，用来进行角色
        iActionId: "", //活动id
        iActionType: "", //活动类型
        sActionNo: "", //活动No
        paytype: "", //支付时：1 – midas h5支付；2 – midas 纯微信支付  //下单时： 点券/钻石1，人民币2，金币3
        apptype: "", //1 – iap；2 – android；3 – html5
        acctype: "", //qq - 手Q授权登录态；wx – 微信授权登录态；默认为pt登录态
        openappid: "", //开放平台appid
        openid: "", //openid
        roleid: "", //角色id
        access_token: "",
        pay_token: "",
        dc: "", //屏蔽支付方式,qqwallet: QQ钱包，qdqb: Q点Q币，qbqd: Q币Q点，qqcard: QQ卡，mcard: 手机充值卡，wechat: 微信支付，hfpay: 手机话费，yb: 元宝
        _t: new Date().getTime(),
    },
    _doCloudBuying: false,
    _doCanceling: false,
    //业务逻辑参数
    _biz_option: {
        areaType: 1, //大区选择框样式、1:h5方案，2:milo默认选择框
        onPaySuccess: null,
        onPayCancel: null,
        onPaySend: null,
        onPayClose: null,
        onBuyError: null,
    },
    //初始化订单信息
    init: function (option) {
        this.fillOption(this._option, option);
        this.fillOption(this._biz_option, option);
        if (this._option._v == "v3") {
            this._option._app_id = this._option.appid;
            this._option._plug_id = this._option.plug_id;
            this._option._biz_code = this._option.biz;
        }
        try {
            if (app.isApp()) {
                this._option.channel = 91001;
            } else if (navigator.userAgent.indexOf("cfapp") > 0) {
                //掌火
                this._option.channel = 92004;
            } else if (navigator.userAgent.indexOf("lolapp") > 0) {
                //掌盟
                this._option.channel = 92001;
            } else if (navigator.userAgent.indexOf("GameHelper") > 0) {
                //助手
                this._option.channel = 92008;
            }
        } catch (e) {}
    },
    //云支付唤起
    pay: function (option) {
        var $this = this;

        option = $.extend({}, $this._option, option);
        $this._doCloudPaying = true; //支付开启
        var _option = {
            _appname: option.biz,
            _app_id: option.appid,
            paytype: option.paytype && option.paytype != "" ? option.paytype : 1, //1 – midas h5支付；2 – midas 纯微信支付
            apptype: option.apptype && option.apptype != "" ? option.apptype : 3, //1 – iap；2 – android；3 – html5
            serial: option.serial, //订单号
            acctype: option.acctype ? option.acctype : Cookies.get("acctype") ? Cookies.get("acctype") : "pt", //qq - 手Q授权登录态；wx – 微信授权登录态；默认为pt登录态
            openid: option.openid ? option.openid : Cookies.get("openid"), //openid
            appid: option.openappid, //如果是走openid开发平台需要传如open_appid
            access_token: option.access_token ? option.access_token : Cookies.get("access_token"), //access_token
            pay_token: option.pay_token, //pay_token
            plat: 0, //1-ios/2-android，默认为0，无用的参数
            _output_fmt: 2,
            // _cs: 1,
            onSuccess: option.onSuccess || function (opt) {},
            onClose: option.onClose || function (opt) {},
            ru: option.ru || location.href, //支付成功后的页面地址
            pu: option.pu || location.href, //支付页面返回左上角按钮地址
            hu: option.hu || location.href //home页面地址
        };
        if (!_option.pay_token) {
            _option.pay_token = Util.request("pay_token");
        }
        //from ams处理
        if (Cookies.get("acctype") && Cookies.get("openid") && Cookies.get("access_token") && Cookies.get("appid")) {
            //openid登录，非msdk
            _option.acctype = Cookies.get("acctype");
            _option.openid = Cookies.get("openid");
            _option.access_token = Cookies.get("access_token");
            _option.appid = Cookies.get("appid");
        }
        //msdk
        else if (Util.request("timestamp") != "" && Util.request("algorithm") != "" && Util.request("msdkEncodeParam") != "" && Util.request("version") != "" && Util.request("sig") != "" && Util.request("encode") != "" && Util.request("appid") != "") {
            _option["appid"] = Util.request("appid");
            _option["timestamp"] = Util.request("timestamp");
            _option["algorithm"] = Util.request("algorithm");
            _option["msdkEncodeParam"] = Util.request("msdkEncodeParam");
            _option["version"] = Util.request("version");
            _option["sig"] = Util.request("sig");
            _option["encode"] = Util.request("encode");
            _option["openid"] = Util.request("openid");
        }

        //游戏内支付from hs
        if (typeof option["msdkappid"] != "undefined") {
            _option["appid"] = option["msdkappid"];
            _option["openid"] = option["openid"];
            _option["timestamp"] = option["timestamp"];
            _option["algorithm"] = option["algorithm"];
            _option["msdkEncodeParam"] = option["msdkEncodeParam"];
            _option["version"] = option["version"];
            _option["sig"] = option["sig"];
            _option["encode"] = option["encode"];
            _option["pay_token"] = option["pay_token"];

            //暂时屏蔽微信支付的Q币Q点支付，待和米大师确认
            if (_option.acctype == "wx") {
                option["dc"] = "qdqb";
            }
        }

        //未指定的apptype，手Q渠道默认为android
        if (_option._app_id == 1000 && _option._appname != "bwzy" && ($this._option.iActionId == "" || $this._option.iActionId < 6150)) {
            _option.apptype = 2;
        }
        //paytype处理
        if (_option.acctype == "wx") {
            _option.paytype = 2;
        } else {
            _option.paytype = 1;
        }

        // var payUrl = _url + "_appname=" + _option._appname + "&_app_id=" + _option._app_id + "&_output_fmt=" + _option._output_fmt + "&paytype=" + _option.paytype + "&apptype=" + _option.apptype + "&acctype=" + _option.acctype + "&openid=" + _option.openid + "&serial=" + _option.serial + "&appid=" + _option.appid + "&access_token=" + _option.access_token + "&plat=" + _option.plat;
        //
        // if(_option.pay_token){
        //     payUrl+= "&pay_token=" + _option.pay_token;
        // }
        //
        // if (_option.timestamp && _option.algorithm && _option.msdkEncodeParam && _option.version && _option.sig && _option.encode) {
        //     payUrl += "&timestamp=" + _option.timestamp + "&algorithm=" + _option.algorithm + "&msdkEncodeParam=" + _option.msdkEncodeParam + "&version=" + _option.version + "&sig=" + _option.sig + "&encode=" + _option.encode;
        // }
        // payUrl += "&r=" + Math.random();
        //唤起云支付


        let pms = {
            // 配置支付参数
            _version: "v3",
            params: option.urlParams,
            pf: option.pf,
            sandbox: option.sandbox == "1" ? "1" : "",
            ru: _option.ru,
            channelStyle: 2, //2: 表示屏蔽渠道订单信息上的数量
            onSuccess: function () {
                _option.onSuccess({
                    iRet: '0',
                    sMsg: '恭喜你购买成功！'
                });
            },
            onClose: function () {
                _option.onClose({
                    iRet: '-9999',
                    sMsg: '关闭支付',
                    serial: _option.serial
                });
            },
        };
        if (option.dc) {
            pms.dc = option.dc;
        }
        if (option.sessionid && (option.sessionid ==
            "openid" || option.sessionid == "hy_gameid")) {

            if(option.dc){//前端屏蔽的支付渠道
                pms.dc = option.dc+",qqcard,mcard";
                // pms.dc = option.dc;
            }else{//默认屏蔽qq卡和手机充值卡支付
                pms.dc = "qqcard,mcard";
            }

            //pms.wxAppid2 = $this.wxappid;
            pms.openid = _option["openid"];
            pms.sessionid = option.sessionid;
            pms.sessiontype = option.sessiontype;
            pms.openkey = _option["access_token"];
            if (pms.sessiontype == "wc_actoken") {
                pms.wxAppid2 = _option.appid;
            }
            if (!pms.openkey) {
                alert('对不起，当前游戏版本尚不支持游戏内购买，请期待后续更新');
            }
        }else if (option.sessiontype && (option.sessiontype == "pskey_8")) {
            pms.openid = option.openid;
            pms.sessionid = option.sessionid;
            pms.sessiontype = option.sessiontype;
            pms.openkey = option.openkey;
        }else if (option.sessiontype && (option.sessiontype == "st_third_party")){
            pms.openid = option.openid;
            pms.sessionid = option.sessionid;
            pms.sessiontype = option.sessiontype;
            pms.openkey = option.openkey;
        }
        Util.getScript("//midas.gtimg.cn/h5pay/js/api/midas.js", function () {
            console.log(pms)
            Midas.buyGoods(pms);
            return;
        });



        //启动
        $this._doCloudBuying = false;
    },
};
//export default Order;

export function mobileOrderSvr() {
    return Order
}
